import { autoCbm, num, round4 } from "./quoteBasisHelpers";

export const calculationFrom = p => ({
  quote_basis: p.quote_basis || null,
  fixed_amount: p.fixed_amount ?? "",
  fixed_description: p.fixed_description || "",
  total_volume_cbm: p.total_volume_cbm ?? "",
  customer_note: p.customer_note || "",
  line_items: (p.line_items || []).map((r, i) => ({ ...r,
    ...Object.fromEntries(["description", "quantity", "length_cm", "width_cm", "height_cm", "weight_kg", "rate"].map(k => [k, r[k] ?? ""])),
    _lid: `pickup-${i}-${crypto.randomUUID()}`, cbm: r.cbm_mode === "auto" ? "" : r.cbm ?? "",
    cbm_mode: r.cbm_mode || (r.cbm == null ? "auto" : "manual"),
  })),
});

export const pickupVolume = rows => round4((rows || []).reduce((sum, row) => sum + autoCbm(row) * (num(row.quantity) || 1), 0));

export const pickupDraftError = calculation => {
  const rows = (calculation.line_items || []).filter(row => ["description", "length_cm", "width_cm", "height_cm", "cbm", "weight_kg", "rate"].some(k => row[k] !== "" && row[k] != null && row[k] !== 0));
  if (rows.some(row => !(Number(row.quantity) > 0))) return "Vul een positief aantal per regel in.";
  if (calculation.quote_basis === "fixed") {
    if (!calculation.fixed_description.trim()) return "Vul een omschrijving voor de vaste vrachtprijs in.";
    if (!(Number(calculation.fixed_amount) > 0)) return "Vul een positieve vaste vrachtprijs in.";
  }
  if (calculation.quote_basis === "lines" && !rows.length) return "Voeg minimaal één calculatieregel toe.";
  if (calculation.quote_basis === "total_volume") {
    const volume = rows.length ? pickupVolume(rows) : Number(calculation.total_volume_cbm);
    if (!(volume > 0)) return "Vul een positief totaalvolume in.";
  }
  return "";
};

export const pickupCalculationPayload = (calculation, shipment, pricing) => {
  const number = value => value === "" || value == null ? null : Number(value);
  const numericLine = ["quantity", "length_cm", "width_cm", "height_cm", "cbm", "weight_kg", "rate"];
  return { ...calculation, fixed_amount: number(calculation.fixed_amount), total_volume_cbm: number(calculation.total_volume_cbm),
    line_items: (calculation.line_items || []).map(({ _lid, ...row }) => ({ ...row,
      ...Object.fromEntries(numericLine.map(k => [k, k === "quantity" && row[k] == null ? 1 : number(row[k])])),
      cbm_mode: row.cbm_mode || (row.cbm === "" || row.cbm == null ? "auto" : "manual"),
    })), shipment, pricing,
  };
};